/* eslint-disable react/prop-types */
import React from 'react'
import classes from "./../ProductsApp.module.css";

export const ProductAppItem = ({ onClick = () => {},imgSrc = '', alt, title}) => 
(<div
    className={classes.box}
    onClick={onClick}
>
    <div className={classes.img_box}>
        <img src={imgSrc} alt={alt} />
    </div>
    <p>{title}</p>
</div>
)